import { objectKeysToCamelCase } from '../core-bundle/helpers/object-keys-camel-case';

import LaunchDarkly from '@app/modules/launchdarkly';

import Helper from '@app/helper';
import { EXPERIMENT_FREE_ACCOUNT } from '@app/constant/experiments';
import { GB } from '@app/constant/sizes';

export function transformUserRules(rules, isUserLoggedIn) {
  if (!rules) return;
  const parsedRules = objectKeysToCamelCase(rules);
  const transferLimit =
    LaunchDarkly.getVariant(EXPERIMENT_FREE_ACCOUNT) && !isUserLoggedIn
      ? 1 * GB
      : parsedRules.transferLimit;

  return {
    ...parsedRules,
    transferLimit,
  };
}

const makeUser = (response) => {
  const {
    id,
    full_name,
    email,
    language,
    transfer_default_expiry,
    plan_tier,
    rules,
    default_recipient_email,
    receiving_email_confirmed,
  } = response;
  const isUserLoggedIn = !!id;
  const user = {
    id,
    full_name,
    email,
    language,
    loggedIn: id,
    preferences: {
      transfer_default_expiry,
    },
    defaults: {
      profile_picture_thumbnail_url: Helper.getAvatar(id),
    },
    planTier: plan_tier,
    rules: transformUserRules(rules, isUserLoggedIn),
    default_recipient_email: default_recipient_email || '',
    receiving_email_confirmed: !!receiving_email_confirmed,
  };

  if (response.memberships && response.memberships[0]) {
    user.memberships = response.memberships;
    user.storageFull = !!response.memberships[0].storage_full;
  }

  user.profile_picture = response.profile_picture || null;

  return user;
};

export default {
  /*
    This method parses the response from either sign_in endpoint
    or the value of bootstrapped window.__session__.user
  */
  auth(response) {
    let account = {};
    let subscription = {};

    const { memberships } = response;

    // Retrieve account from memberships & subscription id
    if (memberships && memberships.length > 0 && memberships[0].account) {
      account = memberships[0].account;
      subscription = account.subscription;
    }

    return {
      user: makeUser(response),
      subscription,
      account,
    };
  },

  /*
    This method parses the response of user endpoint
  */
  user: makeUser,

  account(response) {
    let emailBackground = null;
    // Email background?
    if (response.email_background) {
      emailBackground = response.email_background;
    }

    return {
      ...response,
      email_background: emailBackground,
    };
  },
};
